module.exports = __webpack_public_path__ + "static/media/wordmark-dark-2.a04b16dd.svg";